import { FC, Suspense } from 'react';
import { useAtomValue } from 'jotai';
import HashtagPostSection from './post';
import HashtagCampaignSection from './campaign';
import { HashtagTopicSection } from './related';
import HashtagDescriptionSection from './description';
import { Loading } from '~/components/loading';
import { NotFound } from '~/components/not-found';
import { HashtagBodySkeleton } from '~/skeleton/hashtag';
import { $CurrentAvailableHashtagInfoOrNull } from '~/routes/topic.$hashtag_id/shared/atoms';

export const HashtagBody: FC = () => {
  const hashtag = useAtomValue($CurrentAvailableHashtagInfoOrNull);

  if (!hashtag) {
    return <NotFound />;
  }

  return (
    <>
      <HashtagDescriptionSection />
      <Suspense fallback={<HashtagBodySkeleton />}>
        <HashtagPostSection />
        <HashtagCampaignSection />
        <Suspense fallback={<Loading variant="ball" />}>
          <HashtagTopicSection />
        </Suspense>
      </Suspense>
    </>
  );
};
